/**
 * Small badge that visualizes a membership tier using its display_color.
 */
export default function TierBadge({ tier, size = 'sm', className = '', testID }) {
  if (!tier) return null;
  const color = tier.display_color || '#C9A84C';
  const pad = size === 'lg' ? 'px-3 py-1 text-xs' : 'px-2 py-0.5 text-[10px]';
  return (
    <span
      data-testid={testID}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wider border ${pad} ${className}`}
      style={{
        color,
        background: `${color}22`,
        borderColor: `${color}55`,
      }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full shrink-0"
        style={{ background: color, boxShadow: `0 0 6px ${color}` }}
      />
      {tier.name}
    </span>
  );
}
